import React from "react";
import { useTranslation } from "react-i18next";
import './LowInternet.scss'

const LowInternet = ({isNotOnline}) => {
    const { t } = useTranslation();
    return (
        <>
            {isNotOnline && (
                <div className="low-internet-banner">
                    <div className="low-internet-content">
                        <span><span>&#9888;&#65039;</span>  {t('lowInternet.offline')}</span>
                    </div>
                </div>
            )}
        </>
    )
}

export default LowInternet;